import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, Typography, makeStyles } from "@material-ui/core";
import { Paper, PaperBorderType } from "@roc/ui";
import { useRocInternalPortalStore } from "apps/roc-internal-portal/src/app/hooks";
import { observer } from "mobx-react";
import { useEffect } from "react";

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    overflow: 'hidden',
    border: '1px solid #d5d5d5',
    borderRadius: theme.spacing(2),
  },
}));

export const BankInformation = observer(() => {
  const classes = useStyles();
  const { sendWireInternalStore } = useRocInternalPortalStore();

  useEffect(() => {
    if (sendWireInternalStore?.loanId) {
      sendWireInternalStore.getBankInfo();
    }
  }, [sendWireInternalStore?.loanId])

  return (
    <>
      <Paper borderType={PaperBorderType.SOLID_BORDER} className={classes.paper}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={2}>
                <Typography><strong>Bank information</strong></Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell> Bank Name </TableCell>
              <TableCell>{sendWireInternalStore.bankInformation?.bankName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell> Account Name </TableCell>
              <TableCell>{sendWireInternalStore.bankInformation?.accountName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell> Account Number </TableCell>
              <TableCell>{sendWireInternalStore.bankInformation?.accountNumber}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell> Routing Number </TableCell>
              <TableCell>{sendWireInternalStore.bankInformation?.routingNumber}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell> City </TableCell>
              <TableCell>{sendWireInternalStore.bankInformation?.city}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell> State </TableCell>
              <TableCell>{sendWireInternalStore.bankInformation?.state}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell> Street Name </TableCell>
              <TableCell>{sendWireInternalStore.bankInformation?.streetName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell> Zip Code </TableCell>
              <TableCell>{sendWireInternalStore.bankInformation?.zipCode}</TableCell>
            </TableRow>
          </TableBody>
          <TableHead>
            <TableRow>
              <TableCell colSpan={2}>
                <Typography><strong>FFC Bank information</strong></Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell> FFC Bank Name </TableCell>
              <TableCell>{sendWireInternalStore.bankInformation?.ffcBankName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell> FFC Routing Number </TableCell>
              <TableCell>{sendWireInternalStore.bankInformation?.ffcRoutingNumber}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell> FFC Account Name </TableCell>
              <TableCell>{sendWireInternalStore.bankInformation?.ffcAccountName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell> FFC Account Number </TableCell>
              <TableCell>{sendWireInternalStore.bankInformation?.ffcAccountNumber}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </>
  )
})